import { KnowledgeBaseCategory, KnowledgeBaseEntity, Pagination } from '@edwin-group/people-graphql';
import { create } from 'zustand';

interface KnowledgeBaseListState {
  knowledgeBases: KnowledgeBaseEntity[];
  categories: KnowledgeBaseCategory[];
  rootCategories: KnowledgeBaseCategory[];
  validCategoriesByType: Record<string, string[]>;
  selectedCategoryIds: string[];
  selectedSubcategoryIds: string[];
  pagination: Pagination;
  loading: boolean;
}

interface KnowledgeBaseListActions {
  setKnowledgeBases: (knowledgeBases: KnowledgeBaseEntity[]) => void;
  appendKnowledgeBases: (knowledgeBases: KnowledgeBaseEntity[]) => void;
  setCategories: (categories: KnowledgeBaseCategory[]) => void;
  setRootCategories: (rootCategories: KnowledgeBaseCategory[]) => void;
  setValidCategoriesByType: (map: Record<string, string[]>) => void;
  toggleCategory: (categoryId: string) => void;
  toggleSubcategory: (subcategoryId: string) => void;
  resetFilters: () => void;
  setPagination: (pagination: Pagination) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

const initialState: KnowledgeBaseListState = {
  knowledgeBases: [],
  categories: [],
  rootCategories: [],
  validCategoriesByType: {},
  selectedCategoryIds: [],
  selectedSubcategoryIds: [],
  pagination: {
    page: 1,
    pageCount: 1,
    total: 0,
    pageSize: 10,
  },
  loading: false,
};

export const useKnowledgeBaseListStore = create<KnowledgeBaseListState & KnowledgeBaseListActions>((set) => ({
  ...initialState,
  setKnowledgeBases: (knowledgeBases) => set({ knowledgeBases }),
  appendKnowledgeBases: (knowledgeBases) =>
    set((state) => ({ knowledgeBases: [...state.knowledgeBases, ...knowledgeBases] })),
  setCategories: (categories) => set({ categories }),
  setRootCategories: (rootCategories) => set({ rootCategories }),
  setValidCategoriesByType: (validCategoriesByType) => set({ validCategoriesByType }),
  toggleCategory: (categoryId) =>
    set((state) => ({
      selectedCategoryIds: state.selectedCategoryIds.includes(categoryId) ? [] : [categoryId],
      selectedSubcategoryIds: [],
    })),
  toggleSubcategory: (subcategoryId) =>
    set((state) => ({
      selectedSubcategoryIds: state.selectedSubcategoryIds.includes(subcategoryId)
        ? state.selectedSubcategoryIds.filter((id) => id !== subcategoryId)
        : [...state.selectedSubcategoryIds, subcategoryId],
    })),
  resetFilters: () =>
    set({
      selectedCategoryIds: [],
      selectedSubcategoryIds: [],
    }),
  setPagination: (pagination) => set({ pagination }),
  setLoading: (loading) => set({ loading }),
  reset: () => set(initialState),
}));
